export default __webpack_public_path__ + "static/media/3.dd376ef9.jpg";